import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useI18n, LANGS, LANG_LABELS } from "@/i18n";

export default function LanguageSelector({ className = "" }) {
  const { lang, setLang, t } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={ref} className={`relative ${className}`} data-testid="language-selector">
      <button data-testid="language-selector-button" onClick={() => setOpen((o) => !o)}
        aria-label={t("language")}
        className="flex items-center gap-1.5 rounded-full border border-white/20 bg-black/40 backdrop-blur px-3 py-1.5 text-xs font-mono-x tracking-widest uppercase text-white/80 hover:text-white hover:border-white/40 transition-colors">
        <Globe className="w-3.5 h-3.5" /> {LANG_LABELS[lang]}
      </button>
      {open && (
        <div data-testid="language-menu"
          className="absolute right-0 mt-2 w-32 rounded-xl border border-white/10 bg-[#0c0c0f] shadow-xl overflow-hidden z-50">
          {LANGS.map((l) => (
            <button key={l} data-testid={`language-option-${l}`}
              onClick={() => { setLang(l); setOpen(false); }}
              className={`flex items-center justify-between w-full px-4 py-2.5 text-sm text-left transition-colors ${l === lang ? "text-white bg-white/5" : "text-[#9a9a9a] hover:text-white hover:bg-white/5"}`}>
              <span className="font-mono-x tracking-widest">{LANG_LABELS[l]}</span>
              {l === lang && <Check className="w-3.5 h-3.5 text-[#FF2A2A]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
